module.exports = __webpack_public_path__ + "img/numCard_En.995c8d7a.svg";